export default () => {
    import(/* webpackChunkName: "toast" */ "../classes/bToastClass")
        .then(({ default: Toast }) => {
        new Toast();
    })
        .catch(() => "An error with toast component occurred");
};
